import { matchPath } from "react-router-dom";
import { defaultTranslations } from "../../constants/defaults";
import * as ROUTES from "../../constants/routes";
import { getFrontendChannel } from "../../helpFunctions/channel";
import { getBackendUrl, mergeSettings } from "../../helpFunctions/general";

const decodeRouteParam = value => {
  if (!value) return value;

  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const getFrontendChannelInfo = (frontendChannel = getFrontendChannel(import.meta.env.VITE_CHANNEL)) => {
  switch (frontendChannel) {
    case "main":
      return {
        title: "DEV",
        hasSpecialNavTone: true,
        label: "DEV",
        tooltip: "This is a development version of the app. It may have unfinished features and more bugs.",
      };
    case "alpha":
      return {
        title: "ALPHA",
        hasSpecialNavTone: true,
        label: "ALPHA",
        tooltip: "This is an alpha version of the app. It may have the newest features but also more bugs.",
      };
    case "beta":
      return {
        title: "BETA",
        hasSpecialNavTone: false,
        label: null,
        tooltip: "This is the beta version of the app. It may have the newest features but also more bugs.",
      };
    case "stable":
      return {
        title: "STABLE",
        hasSpecialNavTone: false,
        label: null,
        tooltip: "This is the standard, stable version of the app.",
      };
    default:
      return {
        title: frontendChannel?.toUpperCase?.() || "UNKNOWN",
        hasSpecialNavTone: false,
        label: null,
        tooltip: "This is the current frontend channel.",
      };
  }
};

const resolveScenarioIdFromPath = pathname => {
  const scenarioMatch =
    matchPath(`${ROUTES.SCENARIO}/:id`, pathname) ||
    matchPath(`${ROUTES.LEGACY_SCENARIO_VIEW}/:id`, pathname) ||
    matchPath(`${ROUTES.PLAY_PAGE}/:id`, pathname);
  const scenarioEditorMatch = matchPath(`${ROUTES.SCENARIO_EDITOR}/:id`, pathname);

  return {
    scenarioEditorId: decodeRouteParam(scenarioEditorMatch?.params?.id),
    scenarioId: decodeRouteParam(scenarioMatch?.params?.id),
  };
};

export const resolveCurrentBackendSettings = ({ pathname, state }) => {
  const baseSettings = state?.settings || {};
  const { scenarioEditorId, scenarioId } = resolveScenarioIdFromPath(pathname);

  if (scenarioEditorId) {
    const scenario = state?.scenarios?.find(item => item.id === scenarioEditorId);
    return mergeSettings([baseSettings, scenario?.options || {}]);
  }

  if (scenarioId) {
    const scenario = state?.scenarios?.find(item => item.id === scenarioId);
    return mergeSettings([baseSettings, scenario?.options || {}]);
  }

  return baseSettings;
};

export const resolveCurrentBackendChannel = ({ pathname, state }) => {
  return resolveCurrentBackendSettings({ pathname, state }).backendChannel;
};

export const getBackendChannelTitle = backendChannel => {
  if (!backendChannel || backendChannel === "default") return null;
  return defaultTranslations?.settings?.backendChannel?.[backendChannel]?.title || backendChannel;
};

export const getBackendChannelInfo = settings => {
  const backendChannel = settings?.backendChannel;
  const backendTranslations = defaultTranslations?.settings?.backendChannel;
  const title = backendTranslations?.[backendChannel || "default"]?.title || backendChannel || "default";
  const url = getBackendUrl({ settings, logResolution: false });

  return {
    title,
    url,
  };
};
